// extracted by mini-css-extract-plugin
export var closeButton = "_gc-2";
export var closeButtonIcon = "_gc-3";
export var lightboxContent = "_gc-1";
export var lightboxOverlay = "_gc-0";